export default "__VITE_ASSET__8e02604b__"